import React from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Tabs, Button } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import styled from '@emotion/styled'
import { ParceiroDetailStore } from './parceiroDetailStore'
import { DadosTab } from './dadosTab'

export function ParceiroDetail() {
  const { id } = useParams<{ id: string }>()
  const isNew = id === 'novo'

  function init(dispatch: any) {
    if (!isNew) dispatch(ParceiroDetailStore.thunks.fetch(Number(id)))
  }

  return (
    <ParceiroDetailStore.Provider init={init}>
      <PageLayout>
        <ParceiroDetailHeader />
        <ParceiroDetailTabs />
      </PageLayout>
    </ParceiroDetailStore.Provider>
  )
}

function ParceiroDetailHeader() {
  const { parceiro, totals } = ParceiroDetailStore.useState()
  const { id } = useParams<{ id: string }>()
  const history = useHistory()
  const isNew = id === 'novo'
  const title = isNew ? 'Novo Parceiro' : (parceiro.nome ?? `Parceiro #${id}`)

  return (
    <HeaderRow>
      <TitleGroup>
        <Button icon={<ArrowLeftOutlined />} onClick={() => history.push('/parceiros')}>
          Voltar
        </Button>
        <PageTitle>{title}</PageTitle>
      </TitleGroup>
      {!isNew && (
        <TotalsGroup>
          <StatCard>
            <StatLabel>Matrículas</StatLabel>
            <StatValue>{totals.matriculas}</StatValue>
          </StatCard>
          <StatCard>
            <StatLabel>Valor New Driver</StatLabel>
            <StatValue>
              {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
                Number(totals.valorNewDriver)
              )}
            </StatValue>
          </StatCard>
        </TotalsGroup>
      )}
    </HeaderRow>
  )
}

function ParceiroDetailTabs() {
  const { id } = useParams<{ id: string }>()
  const isNew = id === 'novo'

  const items = [
    { key: 'dados', label: 'Dados', children: <DadosTab /> },
    { key: 'usuarios', label: 'Usuários', children: <UsuariosTabLazy /> },
    ...(!isNew
      ? [
          { key: 'vendas', label: 'Vendas', children: <VendasTabLazy /> },
          { key: 'precos', label: 'Preços', children: <PrecosTabLazy /> },
        ]
      : []),
  ]

  return <Tabs defaultActiveKey="dados" items={items} style={{ marginTop: 16 }} />
}

function UsuariosTabLazy() {
  const UsuariosTab = React.lazy(() =>
    import('./usuariosTab').then((m) => ({ default: m.UsuariosTab }))
  )
  return (
    <React.Suspense fallback={null}>
      <UsuariosTab />
    </React.Suspense>
  )
}

function VendasTabLazy() {
  const VendasTab = React.lazy(() => import('./vendasTab').then((m) => ({ default: m.VendasTab })))
  return (
    <React.Suspense fallback={null}>
      <VendasTab />
    </React.Suspense>
  )
}

function PrecosTabLazy() {
  const PrecosTab = React.lazy(() => import('./precosTab').then((m) => ({ default: m.PrecosTab })))
  return (
    <React.Suspense fallback={null}>
      <PrecosTab />
    </React.Suspense>
  )
}

const PageLayout = styled.div`
  padding: 24px;
  background: whitesmoke;
  min-height: 100%;
`

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

const PageTitle = styled.h2`
  margin: 0;
  font-size: 22px;
  color: #494d50;
`

const TotalsGroup = styled.div`
  display: flex;
  gap: 12px;
`

const StatCard = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 10px 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 120px;
  text-align: center;
`

const StatLabel = styled.div`
  font-size: 11px;
  color: #666;
  margin-bottom: 2px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`

const StatValue = styled.div`
  font-size: 18px;
  color: #494d50;
  font-weight: 600;
`
